export default __webpack_public_path__ + "static/media/i029vp.726bb1a9.webp";